import { FormTab, Group, GroupTitle } from "ra-friendsofbabba";

import Alert from "../../component/Alert";
import { Input } from "../../component/input";
import VerificationField from "../fields/VerificationField";
import { useTranslate } from "react-admin";

const VerificationMeetTab = (props) => {
  const translate = useTranslate();
  return (
    <FormTab
      {...props}
      label="resources.technical-reports.tabs.verification_meet"
    >
      <Group wrapper>
        <GroupTitle
          title={translate(
            "resources.technical-reports.title.verification_meet"
          )}
          subTitle={translate(
            "resources.technical-reports.help.verification_meet"
          )}
        />
        <Alert
          severity="error"
          title="resources.technical-reports.help.verification_meet.alert"
          message="resources.technical-reports.help.verification_meet.alert_message"
        />
        <Input
          source="verification"
          fullWidth
          component={<VerificationField />}
        />
      </Group>
    </FormTab>
  );
};

export default VerificationMeetTab;
